import { Alert, Divider, Grid, Snackbar } from "@mui/material";
import { IGetUserNotificationSettingsQuery } from "api/queries/usersAPI";
import { useStyles } from "../NotificationsModal.styles";
import { NotificationSwitch } from "./NotificationSwitch";
import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import { UsersEntity } from "entities/Users/UsersEntity";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { DefaultTranslationFieldsInTable } from "constants/constants";

export const BirchNotifications = ({
    notifications,
    refetch,
}: {
    notifications: IGetUserNotificationSettingsQuery["user_notification_settings"];
    refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>;
}) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const { enableNotification, apolloMutationError } = UsersEntity.EnableUserNotificationSetting();

    const handleEnablingNotificationSetting = async (id: number, isEnabledChange: boolean) => {
        try {
            await enableNotification({
                variables: { settingId: id, change: isEnabledChange },
            });
            await refetch();
            setShowSnackbar(true);
            setSnackbarMessage(
                t("corporate_backoffice.corporate_layout.app_drawer.app_toolbar.notification_modal.update_success"),
            );
        } catch {
            setShowSnackbar(true);
            setSnackbarMessage(
                t("corporate_backoffice.corporate_layout.app_drawer.app_toolbar.notification_modal.update_error"),
            );
        }
    };

    return (
        <Grid container spacing={2}>
            {notifications.map((notification) => (
                <Grid key={notification.id} item xs={12}>
                    <NotificationSwitch
                        margin
                        size={12}
                        name={translateDefaultEntity(
                            i18n.language,
                            notification.email_notification_type as IGetUserNotificationSettingsQuery["user_notification_settings"][0]["email_notification_type"] & {
                                name: string;
                            },
                            "type",
                            DefaultTranslationFieldsInTable.EMAIL_NOTIFICATION_TYPE,
                        )}
                        isEnabled={notification.is_enabled}
                        handleChange={async () => {
                            await handleEnablingNotificationSetting(notification.id, !notification.is_enabled);
                        }}
                    />
                    <Divider className={classes.divider} />
                </Grid>
            ))}

            <Snackbar
                open={showSnackbar}
                onClose={() => {
                    setShowSnackbar(false);
                    setSnackbarMessage("");
                }}
                autoHideDuration={6000}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <Alert severity={apolloMutationError ? "error" : "success"} sx={{ width: "100%" }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Grid>
    );
};
